export default {
    'privacy.title': 'プライバシーポリシー',
} as Record<string, string>;
